import { Box, Button, ButtonProps } from '@mui/material';
import { AI_GRADIENT, aiGradientButtonSx, AIGradientSpinner, AIGradientText } from './AIGradient.styles';

export { AI_GRADIENT, AI_GRADIENT_ANIMATED, AIGradientText, AIGradientSpinner } from './AIGradient.styles';

// The Scalar AI action button. Takes any Button prop so callers can add their own
// handlers, test ids, or menu-trigger attributes without losing the gradient look.
export const AIGradientButton = ({ children, sx, ...buttonProps }: ButtonProps) => (
  <Button {...buttonProps} sx={[aiGradientButtonSx, ...(Array.isArray(sx) ? sx : [sx])]}>
    <Box component="img" src="/images/scalar_ai_white.png" alt="Scalar AI" sx={{ width: 18, height: 18 }} />
    {children}
  </Button>
);
